import React, { useEffect, useState } from 'react';

const TAG_LABELS = {
  feature: 'Feature',
  fix: 'Fix',
  polish: 'Polish',
};

function formatDate(iso) {
  if (!iso) return '';
  // Render a stable, on-brand date independent of locale formatting
  const d = new Date(iso + 'T00:00:00');
  if (Number.isNaN(d.getTime())) return iso;
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
}

export default function PatchNotes() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/patch_notes.json')
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then((d) => setData(d))
      .catch((e) => setError(e.message));
  }, []);

  if (error) {
    return (
      <div>
        <div className="page-header">
          <div className="page-title">Patch Notes</div>
          <div className="page-subtitle">Version history</div>
        </div>
        <div className="empty-state">
          <p>Could not load patch notes.</p>
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div>
        <div className="page-header">
          <div className="page-title">Patch Notes</div>
          <div className="page-subtitle">Version history</div>
        </div>
        <div className="loading">
          <div className="spinner" />
          <span>Loading version history...</span>
        </div>
      </div>
    );
  }

  const releases = data.releases || [];

  return (
    <div>
      <div className="page-header">
        <div className="page-title">Patch Notes</div>
        <div className="page-subtitle">
          {releases.length} release{releases.length === 1 ? '' : 's'} ·
          {' '}LeagueIntel changelog
        </div>
      </div>

      <div className="patchnotes-list">
        {releases.map((r, i) => (
          <article key={`${r.version}-${i}`} className="patchnote-entry">
            <header className="patchnote-head">
              <span className="patchnote-version">{r.version}</span>
              <span className="patchnote-date">{formatDate(r.date)}</span>
              {r.tag && (
                <span className={`patchnote-tag ${r.tag}`}>
                  {TAG_LABELS[r.tag] || r.tag}
                </span>
              )}
            </header>
            {r.title && <h2 className="patchnote-title">{r.title}</h2>}
            {Array.isArray(r.changes) && r.changes.length > 0 && (
              <ul className="patchnote-changes">
                {r.changes.map((change, j) => (
                  <li key={j}>{change}</li>
                ))}
              </ul>
            )}
          </article>
        ))}
      </div>
    </div>
  );
}
